var map = {
	"./blog-big-1.jpg": 3990,
	"./blog-big-2.jpg": 48,
	"./blog-big-3.jpg": 4446,
	"./team-01.jpg": 7138,
	"./team-02.jpg": 2862,
	"./team-03.jpg": 5391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9773;